import styled from "styled-components";

export const HeaderDrawerWrap = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  width: 280px;
  height: 100dvh;
  background: rgb(255, 255, 255);
  transition: 0.4s ease-in-out;
  .closeIcon {
    position: absolute;
    top: 15px;
    left: 15px;
    transition: 0.4s ease-in-out;
    background: transparent;
    border: none;
    &:hover {
      color: rgb(255, 24, 24);
    }
  }

  .drawerInner {
    margin-top: 50px;
    text-align: center;

    .headerLogo {
      max-width: 185px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .mobile_menu_inner {
      margin-top: 25px;
      list-style: none;
      padding: 0;
      height: calc(100dvh - 142px);
      overflow-y: auto;
      > li {
        font-weight: 500;
        transition: 0.4s ease-in-out;
        flex-wrap: wrap;
        > a {
          display: flex;
          justify-content: space-between;
          gap: 10px;
          align-items: center;
          width: 100%;
          padding: 5px 15px;
          text-align: left;
          text-decoration: none;
          transition: all 0.4s ease-in-out;
          .arrow {
            min-width: 15px;
            min-height: 15px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 0;
            transition: 0.4s ease-in-out;
            &.rotate {
              transform: rotate(180deg);
            }
          }
        }

        &.active > a,
        &:hover > a {
          color: rgb(255, 24, 24);
        }

        .submenuUl {
          width: 100%;
          list-style: none;
          padding: 0;
          padding: 10px;
          li {
            background: rgb(201 198 198 / 17%);
            a {
              display: flex;
              justify-content: space-between;
              width: 100%;
              padding: 5px 15px;
              text-align: left;
              text-decoration: none;
              color: rgb(0, 0, 0);
              transition: 0.4s ease-in-out;
              &:hover {
                background: rgba(17, 17, 17, 0.5);
                color: rgb(255, 255, 255);
              }
            }
            &.active_subList {
              a {
                background: rgba(17, 17, 17, 0.5);
                color: rgb(255, 255, 255);
              }
            }
          }
        }
      }
    }

    .menu_accordion {
      .menuBody {
        max-height: 0;
        overflow: hidden;
        transition: 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
        width: 100%;
      }

      &.expanded {
        .menuBody {
          max-height: inherit;
        }
      }
    }
  }
`;
